export default __webpack_public_path__ + "static/media/Citizen_Logo_White.d94b75fd.png";